import styled from "styled-components";

export const GeneralMeetingInfoGroup = styled.div`
    margin: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
`;

export const GeneralMeetingInfoContainer = styled.div`
    margin: 10px;
`;
